<template>
	<div class="container__subheaderbuttons__buttons">
		<div
			v-for="(labelAndLinkNameIndividual, key) in labelAndLinkName"
			:key="key"
			class="container__subheaderbuttons__buttons__group"
		>
			<Button
				class="container__subheaderbuttons__buttons__group__item"
				color="trv-primary"
				semantic-class="mini"
				width-auto
				:label="labelAndLinkNameIndividual.label"
				:outlined="activeRoute !== labelAndLinkNameIndividual.linkName"
				@click="changeRoute(labelAndLinkNameIndividual.linkName)"
			/>
		</div>
	</div>
</template>

<script>
import Button from '../Button/Button'
export default {
	components: { Button },
	props: {
		activeRoute: String,
		changeRoute: Function,
		labelAndLinkName: Array,
	},
}
</script>

<style scoped>
.container__subheaderbuttons__buttons {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}

.container__subheaderbuttons__buttons__group {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
	margin-top: 1rem;
}

@media screen and (min-width: 992px) {
	.container__subheaderbuttons__buttons {
		display: flex;
		flex-wrap: wrap;
	}

	.container__subheaderbuttons__buttons__group {
		margin: 0;
		width: auto;
	}

	.container__subheaderbuttons__buttons__group__item.outlined {
		transition: transform 0.2s ease-in-out;
	}

	.container__subheaderbuttons__buttons__group__item.outlined:hover {
		transform: translateY(-0.2rem);
	}
}
</style>
